/* TODO: t() */
import React, { useCallback } from 'react';

import { useCurrencyContext } from '../../../CurrencyContext';
import { Checkbox, CheckboxList, RadioGroup, RadioItem } from '../../../uiold';
import Dropdown from '../../../uiold/Dropdown';
import { ensureDefaultSelected } from '../helpers/MultichoiceHelpers';
import {
  formatChoiceWithCharge,
  parseChargeFromValue,
} from '../../../../support/shared/calculatePrice';

import { MultichoiceElementDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: MultichoiceElementDefinition;
  value: Array<string>;
  onChange: (id: string, value: Array<string>) => void;
};

function MultichoiceElementEditView(props: Props) {
  let { definition, onChange, value = [] } = props;
  let { id, options } = definition;
  let { currency } = useCurrencyContext();
  let selected = ensureDefaultSelected(definition, value);

  let onSingleSelectionChange = useCallback(
    (value: unknown) => {
      onChange && onChange(id, [String(value) ?? '']);
    },
    [onChange, id],
  );

  // Only used when `definition.allow_multi` is true.
  let onCheckboxSelectionChange = useCallback(
    (selectedKeys: Set<string>) => {
      let selected = options
        .filter((option) => selectedKeys.has(option.id))
        .map((option) => option.id);
      onChange && onChange(id, selected);
    },
    [onChange, options, id],
  );

  let optionsWithCharge = parseChargeFromValue(options);

  if (definition.condensed) {
    let choices = optionsWithCharge.map(({ id, name, charge, operator }) => ({
      id,
      name: formatChoiceWithCharge(name, charge, currency, operator),
    }));
    let [selectedChoice] = choices.filter(({ id }) => id === selected[0]);

    return (
      <Dropdown
        options={choices}
        value={selectedChoice}
        onChange={({ id }) => onSingleSelectionChange(id)}
      />
    );
  }

  if (definition.allow_multi) {
    return (
      <CheckboxList
        showSelectAll={options.length >= 4 && !definition.disable_select_all}
        alignHorizontal
        onSelectionChange={onCheckboxSelectionChange}
      >
        {optionsWithCharge.map((option) => {
          let { name, value, charge, operator, id: optionId } = option;
          let formattedOption = formatChoiceWithCharge(
            name,
            charge,
            currency,
            operator,
          );
          let isChecked = selected.includes(optionId);
          return (
            <Checkbox
              key={optionId}
              isChecked={isChecked}
              text={charge ? formattedOption : value}
            />
          );
        })}
      </CheckboxList>
    );
  } else {
    return (
      <RadioGroup
        selectedValue={value[0]}
        alignHorizontal
        onChange={onSingleSelectionChange}
      >
        {optionsWithCharge.map((option, i) => {
          let { name, charge, operator, id } = option;
          let formattedOption = formatChoiceWithCharge(
            name,
            charge,
            currency,
            operator,
          );
          return (
            <RadioItem
              key={i}
              value={id}
              title={charge ? formattedOption : name}
            />
          );
        })}
      </RadioGroup>
    );
  }
}

export default MultichoiceElementEditView;
